import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vc-recurrence-preview-dialog',
  template: `
    <div class="modal-header">
      <h2>Recurrence Schedule</h2>
      <mat-icon class="close-icon" (click)="dialogRef.close()">close</mat-icon>
    </div>
    <div class="modal-body">
      <div class="occurrences-table-wrap">
        <table class="occurrences-table">
          <thead>
            <tr>
              <th>Occurrence Date</th>
              <th>Calculated Due Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let occ of occurrences">
              <td>{{ occ.occurrenceDate | date:'mediumDate' }}</td>
              <td>{{ occ.calculatedDueDate | date:'mediumDate' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
  styles: [`
    .modal-header {
      padding: 16px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e2e8f0;
      h2 { margin: 0; font-size: 15px; font-weight: 600; color: #1a1a2e; font-family: 'Poppins', sans-serif; }
      .close-icon { cursor: pointer; color: #999; &:hover { color: #333; } }
    }
    .modal-body { padding: 16px 24px; }
    .occurrences-table-wrap {
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      max-height: 300px;
      overflow-y: auto;
    }
    .occurrences-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 12px;
      font-family: 'Poppins', sans-serif;
      th { text-align: left; padding: 10px 12px; background: #f8fafc; color: #64748b; border-bottom: 1px solid #e2e8f0; position: sticky; top: 0; }
      td { padding: 8px 12px; color: #334155; border-bottom: 1px solid #f1f5f9; }
    }
  `],
  standalone: false
})
export class RecurrencePreviewDialogComponent {
  occurrences: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<RecurrencePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.occurrences = data.occurrences || [];
  }
}
